<template>
  <div>
    <div class="d-flex justify-content-between">
      <span class="fs-4 fw-semibold">{{ $t('network.auth.loginAsAnotherUser') }}</span>
      <button id="close" data-test="close" type="button" class="close btn-close float-end fs-4" @click.prevent="$emit('close')"></button>
    </div>
    <hr>
    <div>
      <div v-if="busy" class="alert alert-secondary">
        <i class="fas fa-spinner fa-spin"></i>
        {{ $t('network.auth.loggingYouIn') }}
      </div>
      <div v-if="success" class="alert alert-success">{{ $t('network.auth.success') }}</div>

      <form method="POST" @submit.prevent="login">
        <div class="form-group">
          <input
            id="user_name"
            v-model="form.user_name"
            data-test="user_name"
            :placeholder="$t('network.auth.usernameOrEmail')"
            name="user_name"
            type="text"
            required
            class="form-control"
            @input="searchUsers"
          />
          <ul v-if="searchResults.length" class="list-group w-100 pointer">
            <li
              v-for="user in searchResults"
              :key="user.id"
              class="list-group-item list-group-item-action"
              @click="selectUser(user)"
            >
              {{ user.fullname }} ({{ user.email }})
            </li>
          </ul>
        </div>

        <button id="login" data-test="login" class="btn btn-lg btn-block btn-primary mt-3" style="padding: 0.425rem 1.7rem !important;">
          {{ $t('network.auth.login') }}
          <i v-if="busy" class="fas fa-spinner fa-spin"></i>
        </button>
      </form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      success: false,
      busy: false,
      show: false,
      form: {
        user_name: '',
      },
      searchResults: [],
    };
  },
  methods: {
    searchUsers() {
      const searchTerm = this.form.user_name;
      if (searchTerm.length < 3) {
        this.searchResults = [];
        return;
      }

      this.$http.get('users?limit=5&query=' + searchTerm).then((resp) => {
        this.searchResults = resp.data;
      }).catch((error) => {
        console.error('Error fetching users:', error);
      });
    },
    selectUser(user) {
      this.form.user_name = user.user_name;
      this.searchResults = [];
      this.login();
    },
    login() {
      this.busy = true; // show the spinner

      this.$store
        .dispatch('loginAs', this.form)
        .then(() => {
          this.busy = false;
          this.show = false;
          this.$emit('loginAsSuccess');
        })
        .catch(() => {
          this.busy = false;
        });
    },
  },
};
</script>
